import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import RefundTransactionModal from "./components/RefundTransectionModal";
import DMTTransactionStatusCheckModal from "./components/DMTStatusCheckModal";

function PPIDMTScreen() {
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  const [modalShow, setModalShow] = useState(false);
  const [checkmodalShow, setcheckModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate()
  const {userid} =useSession();

  const handleRefudnModal = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };
  const handleStatusCheckModal = () => {
    setModalMode("add");
    setSelectedUser(null);
    setcheckModalShow(true);
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      console.log("inside this1")
      const response = await fetchWrapper(
        `https://api.mokshiq.in/get_user_profile?user=${userid}`
      );
     
      console.log("inside this")
      console.log(response);
      setData(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // hide loader
    }
  };
  useEffect(() => {
    

    fetchData();
  }, []);




  const onboardingPS = async () =>{
    try{
    setLoading(true);
        const formData = new FormData();
        // formData.append("userid", "3");
        const result = await fetchWrapper(
          `https://api.mokshiq.in/paeps_agent_onboarding?userid=${userid}`,
        );
       
       
        if (result.status){
            showMainToast(result.data.message || "BC Agent Registered Successfully", "success")
            fetchData();
        }
        else{
            showMainToast(result.data.message || "Please check your profile details!, Fill all the details carefully", "danger")
        }
        // setData(result.data);
      } catch (err) {
        showMainToast( "Something went wrong!..", "danger")
      } finally {
        setLoading(false); // hide loader
      }
    
  }
  const generateUrlPS = async () =>{
    try{
    setLoading(true);
        const formData = new FormData();
        // formData.append("userid", "3");
        const result = await fetchWrapper(
          `https://api.mokshiq.in/paeps_agent_generateurl?userid=${userid}`,
        );
        
       
        if (result.status && result.data?.data?.url && result.data?.data?.encdata) {
            showMainToast(result.data.message || "URL Generated Successfully", "success")
            const { url, encdata } = result.data.data;
      
            // ✅ Create a hidden form dynamically
            const form = document.createElement("form");
            form.method = "POST";
            form.target = "_blank";
            form.action = url;
            form.style.display = "none";
      
            const input = document.createElement("textarea");
            input.name = "encdata";
            input.value = encdata;
            form.appendChild(input);
      
            document.body.appendChild(form);
      
            // ✅ Auto-submit the form
            form.submit();
          }
        else{
            showMainToast(result.data.message || "Please check your profile details!, Fill all the details carefully", "danger")
        }
        // setData(result.data);
      } catch (err) {
        showMainToast( "Something went wrong!..", "danger")
      } finally {
        setLoading(false); // hide loader
      }
    
  }

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">Wallet DMT</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Wallet DMT
                </a>
              </li>
            </ul>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {/* ✅ Three condition cases */}
            {data?.paeps_agent_onboarding === true ? (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick DMT</h5>
                    <p className="mb-0 text-secondary">
                      Auth Bank KYC already completed ✅
                    </p>
                  </div>
                  <div className="card-body">
                    <button className="btn btn-primary btn-md" type="button" onClick={generateUrlPS}>
                      Generate URL
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick DMT</h5>
                    <p className="mb-0 text-secondary">
                      Submit KYC – Aadhaar, PAN, and Bank details.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={onboardingPS}
                    >
                      Start Onboarding
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Refund Transaction</h5>
                    <p className="mb-0 text-secondary">
                      Have problem with transaction, refund it.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={handleRefudnModal}
                    >
                      Start Refund
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Status Check</h5>
                    <p className="mb-0 text-secondary">
                      Have problem with transaction, check status.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={handleStatusCheckModal}
                    >
                      Check Status
                    </button>
                  </div>
                </div>
              </div>

            
          </div>
        )}
      </div>
      <RefundTransactionModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
      />
      <DMTTransactionStatusCheckModal
        show={checkmodalShow}
        onClose={() => setcheckModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
      />
    </main>
  );
}

export default PPIDMTScreen;
